import { motion } from 'framer-motion'
import { XCircle, ArrowLeft } from 'lucide-react'

export default function PaymentCancel({ onNavigate }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white border border-[#E5E7EB] rounded-2xl p-10 text-center shadow-card">
        <div className="w-14 h-14 bg-red-50 border border-red-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle size={28} className="text-red-500" />
        </div>
        <h1 className="font-sans font-bold text-2xl text-[#111111] mb-2">Payment cancelled</h1>
        <p className="font-body text-[#6B7280] text-sm leading-relaxed mb-6">
          No charge was made. You can book a consultation any time — just click "Start a Project" on the site.
        </p>
        <button onClick={() => onNavigate && onNavigate('hero')}
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#111111] text-white text-sm font-semibold rounded-xl hover:bg-[#0047AB] transition-colors">
          <ArrowLeft size={14} /> Back to site
        </button>
      </motion.div>
    </div>
  )
}
